import React from 'react';

const Pagination = ({ 
    currentPage, 
    totalPages, 
    itemsPerPage, 
    totalItems, 
    onPageChange, 
    onItemsPerPageChange 
}) => {
    const getPageNumbers = () => {
        const pages = [];
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, currentPage + 2);
        
        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) pages.push('...');
        }
        
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }
        
        return pages;
    };
    
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, totalItems);
    
    return (
        <div className="mt-8 flex flex-col items-center gap-4">
            <div className="flex justify-center items-center gap-2 flex-wrap">
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-4 py-2 border border-gray-300 bg-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gradpath-green hover:text-white hover:border-gradpath-green transition-all inline-flex items-center gap-2"
                >
                    <i className="fas fa-chevron-left"></i> Previous
                </button>
                
                <div className="flex gap-1 flex-wrap">
                    {getPageNumbers().map((page, index) => (
                        <button
                            key={index}
                            onClick={() => typeof page === 'number' && onPageChange(page)}
                            className={`min-w-[36px] h-9 flex items-center justify-center border rounded-lg transition-all ${
                                page === currentPage
                                    ? 'bg-gradpath-green text-white border-gradpath-green'
                                    : page === '...'
                                    ? 'border-none cursor-default'
                                    : 'border-gray-300 bg-white hover:bg-gradpath-green hover:text-white'
                            }`}
                            disabled={page === '...'}
                        >
                            {page}
                        </button>
                    ))}
                </div>
                
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 border border-gray-300 bg-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gradpath-green hover:text-white hover:border-gradpath-green transition-all inline-flex items-center gap-2"
                >
                    Next <i className="fas fa-chevron-right"></i>
                </button>
            </div>
            
            <div className="flex flex-col sm:flex-row items-center gap-4">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                    <span>Show:</span>
                    <select
                        value={itemsPerPage}
                        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                        className="px-2 py-1 border border-gray-300 rounded-lg focus:border-gradpath-green focus:ring-1 focus:ring-gradpath-green outline-none"
                    >
                        <option value={10}>10 per page</option>
                        <option value={20}>20 per page</option>
                        <option value={50}>50 per page</option>
                        <option value={100}>100 per page</option>
                    </select>
                </div>
                
                <div className="text-sm text-gray-500">
                    Showing {startItem} - {endItem} of {totalItems} jobs
                </div>
            </div>
        </div>
    );
};

export default Pagination;